var _path, _path2, _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEsim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 367,
    height: 276,
    viewBox: "0 0 367 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M113.938 21.6308C138.064 3.60437 168.669 -3.4203 198.241 2.2813L270.793 16.2698C325.947 26.9037 363.489 78.3744 356.767 134.14L354.019 156.936C347.576 210.389 302.42 250.729 248.582 251.128L144.646 251.899C112.608 252.136 82.1491 238.005 61.6421 213.389L55.4535 205.96C16.207 158.849 24.4988 88.459 73.6182 51.7576L113.938 21.6308Z",
    fill: "#F5F7F9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M172.275 24.0091C208.69 16.591 246.346 28.599 271.745 55.7285L292.764 78.1802C326.931 114.677 328.175 171.034 295.65 209.001C270.007 238.936 228.933 250.608 191.38 238.633L131.92 219.672C94.3669 207.697 67.6331 174.402 64.0529 135.148C59.5118 85.3609 93.1508 40.1274 142.139 30.1481L172.275 24.0091Z",
    fill: "#FFE6DF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3124_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M200.894 110.637C240.163 72.0752 303.388 120.872 273.323 166.971C267.611 175.729 259.087 182.28 249.154 185.546L147.264 219.04C130.056 224.696 111.14 220.845 97.5132 208.911C58.7047 174.922 88.8008 111.36 139.687 119.841L160.772 123.355C175.367 125.788 190.337 121.004 200.894 110.637Z",
    fill: "#3F3D56"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3124_8344)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M301.223 217.542C301.223 217.795 301.02 217.999 300.766 217.999H99.9575C99.7038 217.999 99.5 217.795 99.5 217.542C99.5 217.288 99.7038 217.084 99.9575 217.084H300.766C301.02 217.084 301.223 217.288 301.223 217.542Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.889 195.266L241.196 204.878L234.275 206.8L232.737 196.419L238.889 195.266Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.039 164.123L242.734 170.275L238.12 177.58L244.656 181.809L255.806 169.121L250.039 164.123Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.732 100.686L253.883 121.447C253.883 121.447 281.181 145.285 278.49 150.283C275.798 155.281 257.728 169.122 257.728 169.122C257.728 169.122 259.069 173.548 255.131 171.72C251.192 169.891 246.963 164.893 246.963 164.893C246.963 164.893 246.963 161.048 248.885 161.817C250.807 162.586 259.65 152.205 259.65 152.205L240.427 134.519V193.658C240.427 193.658 245.04 197.692 240.427 198.017C235.813 198.343 231.584 199.112 231.584 199.112C231.584 199.112 226.201 197.189 228.123 195.267L222.356 163.74L218.127 125.292L221.203 105.299L247.732 100.686Z",
    fill: "#1A1924"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.428 203.725C235.428 203.725 235.813 202.188 237.351 202.188H242.048C242.048 202.188 243.502 208.724 243.118 208.724C242.733 208.724 249.27 217.182 242.349 217.567C235.428 217.951 233.506 217.182 233.506 217.182L232.737 214.147C232.737 214.147 231.584 212.184 231.968 210.646C232.353 209.108 235.428 203.725 235.428 203.725Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M245.041 178.734C245.041 178.734 249.457 178.664 248.402 179.852C247.348 181.041 245.425 182.963 245.425 182.963C245.425 182.963 240.852 192.19 238.717 190.46C236.582 188.73 233.122 169.506 234.275 167.199C235.429 164.893 236.967 164.893 236.967 164.893L244.06 169.159C244.06 169.159 239.658 179.887 245.041 178.734Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.275 68.0052L235.813 58.3933L225.432 54.1641L223.895 68.7742L234.275 68.0052Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M234.275 68.0052L235.813 58.3933L225.432 54.1641L223.895 68.7742L234.275 68.0052Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M223.318 66.6598L235.621 63.584L248.693 67.8132C248.693 67.8132 254.46 83.9612 252.538 89.7284C250.615 95.4956 250.615 106.76 250.615 106.76C250.615 106.76 250.423 101.839 239.273 105.3C228.124 108.76 220.049 108.376 220.049 108.376L219.665 94.5344L214.835 82.24C212.771 76.9851 214.996 71.0188 219.997 68.3991L223.318 66.6598Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M279.795 111.952C281.531 114.032 281.865 116.613 280.542 117.718C279.218 118.823 276.738 118.032 275.001 115.951C274.296 115.129 273.798 114.151 273.549 113.097L266.305 104.192L269.834 101.336L277.247 110.012C278.239 110.446 279.113 111.111 279.795 111.952Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.135 67.9355L245.613 77.9228L257.954 97.6768L270.552 110.338L274.635 106.95L261.93 91.1421L252.299 70.7735L248.135 67.9355Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.512 58.2953C286.3 57.6458 292.758 48.1068 291.936 36.9892C291.115 25.8717 283.325 17.3856 274.536 18.035C265.748 18.6845 259.29 28.2235 260.112 39.3411C260.933 50.4586 268.723 58.9447 277.512 58.2953Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.178 58.2949H276.409V134.974H277.178V58.2949Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M277.369 56.6758L277.461 59.3929L278.689 61.9082L273.566 61.6469L275.719 59.4809L275.476 57.0121L277.369 56.6758Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.651 61.4826C237.498 61.4826 242.237 56.743 242.237 50.8966C242.237 45.0501 237.498 40.3105 231.651 40.3105C225.805 40.3105 221.065 45.0501 221.065 50.8966C221.065 56.743 225.805 61.4826 231.651 61.4826Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.807 36.6649C231.113 36.8437 231.523 36.5732 231.622 36.2324C231.72 35.8916 231.605 35.5297 231.492 35.1936L230.921 33.5019C230.516 32.3021 230.086 31.0604 229.208 30.1472C227.884 28.7688 225.78 28.4182 223.886 28.6722C221.453 28.9984 219.052 30.3157 217.921 32.4941C216.79 34.6725 217.272 37.7121 219.316 39.0712C216.403 42.41 215.387 46.1311 215.547 50.5592C215.708 54.9873 220.533 59.0627 223.68 62.1821C224.383 61.7561 225.022 59.7597 224.635 59.0344C224.249 58.3091 224.803 57.4689 224.324 56.8008C223.845 56.1328 223.445 57.1965 223.929 56.5323C224.234 56.1131 223.043 55.1488 223.496 54.8979C225.692 53.6845 226.422 50.9483 227.8 48.8529C229.463 46.3256 232.31 44.614 235.322 44.3301C236.981 44.1737 238.733 44.457 240.094 45.4202C241.454 46.3835 242.334 48.1049 242.019 49.7414C242.835 48.912 243.242 47.6967 243.089 46.5428C242.935 45.389 242.225 44.322 241.22 43.7348C241.831 41.7139 241.308 39.3894 239.89 37.8255C238.471 36.2617 232.717 36.5281 230.647 36.9396",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.485 44.3906C227.743 44.6867 225.763 47.0624 224.09 49.2564C223.127 50.521 222.117 51.9175 222.141 53.5072C222.166 55.1146 223.24 56.4932 223.754 58.0164C224.593 60.5062 223.775 63.4685 221.777 65.1745C223.751 65.5492 225.886 64.0687 226.227 62.0879C226.624 59.7821 224.876 57.5567 225.083 55.2262C225.265 53.173 226.883 51.5928 228.259 50.0576C229.634 48.5224 230.926 46.4852 230.293 44.5235",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.389 108.182H141.315C132.347 108.182 125.078 115.451 125.078 124.418V201.095C125.078 210.062 132.347 217.332 141.315 217.332H220.389C229.357 217.332 236.626 210.062 236.626 201.095V124.418C236.626 115.451 229.357 108.182 220.389 108.182Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M220.39 217.716H141.315C132.15 217.716 124.694 210.26 124.694 201.095V124.418C124.694 115.253 132.15 107.797 141.315 107.797H220.39C229.554 107.797 237.011 115.253 237.011 124.418V201.095C237.011 210.26 229.554 217.716 220.39 217.716ZM141.315 108.566C132.574 108.566 125.463 115.677 125.463 124.418V201.095C125.463 209.836 132.574 216.947 141.315 216.947H220.39C229.131 216.947 236.242 209.836 236.242 201.095V124.418C236.242 115.677 229.131 108.566 220.39 108.566H141.315Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.046 115.726C213.059 115.726 213.88 114.905 213.88 113.892C213.88 112.88 213.059 112.059 212.046 112.059C211.033 112.059 210.212 112.88 210.212 113.892C210.212 114.905 211.033 115.726 212.046 115.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M217.088 115.726C218.101 115.726 218.922 114.905 218.922 113.892C218.922 112.88 218.101 112.059 217.088 112.059C216.076 112.059 215.255 112.88 215.255 113.892C215.255 114.905 216.076 115.726 217.088 115.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.13 115.726C223.143 115.726 223.964 114.905 223.964 113.892C223.964 112.88 223.143 112.059 222.13 112.059C221.118 112.059 220.297 112.88 220.297 113.892C220.297 114.905 221.118 115.726 222.13 115.726Z",
    fill: "#3F3D56"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.723 190.488C138.153 190.488 137.689 190.952 137.689 191.521C137.689 191.799 137.797 192.056 137.991 192.246C138.188 192.447 138.445 192.554 138.723 192.554H221.423C221.992 192.554 222.456 192.091 222.456 191.521C222.456 191.244 222.349 190.987 222.154 190.797C221.958 190.596 221.7 190.488 221.423 190.488H138.723Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.943 190.145V192.899H138.723C138.344 192.899 137.999 192.748 137.752 192.493C137.497 192.245 137.345 191.901 137.345 191.522C137.345 190.764 137.965 190.145 138.723 190.145L182.943 190.145Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M219.701 184.978H205.927C204.408 184.978 203.172 183.743 203.172 182.224C203.172 180.704 204.408 179.469 205.927 179.469H219.701C221.22 179.469 222.456 180.704 222.456 182.224C222.456 183.743 221.22 184.978 219.701 184.978Z",
    fill: "#E6E6E6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.954 186.947L158.325 154.594L157.588 154.813L167.183 187.052",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.287 113.317C177.075 112.667 183.533 103.128 182.712 92.0107C181.89 80.8931 174.1 72.407 165.312 73.0565C156.524 73.7059 150.065 83.245 150.887 94.3626C151.709 105.48 159.499 113.966 168.287 113.317Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.953 113.316H167.184V189.996H167.953V113.316Z",
    fill: "#2F2E41"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.758 153.656L159.621 156.234L161.515 158.295L156.53 159.505L157.977 156.815L157.039 154.518L158.758 153.656Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.145 111.697L168.237 114.414L169.465 116.93L164.342 116.668L166.495 114.502L166.252 112.034L168.145 111.697Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.017 154.333C167.247 151.184 170.691 140.191 166.708 129.779C162.725 119.367 152.824 113.479 144.593 116.627C136.363 119.776 132.919 130.769 136.902 141.181C140.885 151.593 150.786 157.481 159.017 154.333Z",
    fill: "#FD5B2C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.88 104.247C231.474 105.03 233.172 107.003 232.673 108.653C232.175 110.304 229.668 111.007 227.074 110.223C226.033 109.924 225.079 109.381 224.292 108.637L213.345 105.181L214.723 100.855L225.684 104.028C226.752 103.844 227.848 103.92 228.88 104.247Z",
    fill: "#FFB6B6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.861 75.8862L221.395 67.4277L221.011 83.5758L210.245 97.4169L221.78 102.031L221.395 108.618C221.395 108.618 206.785 105.106 204.478 104.722C202.171 104.337 200.249 98.9548 200.249 98.9548L209.861 75.8862Z",
    fill: "#E6E6E6"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3124_8344",
    x: 59.8462,
    y: 50.6855,
    width: 301.329,
    height: 224.918,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 30,
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 25
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.411765 0 0 0 0 0.172549 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3124_8344"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3124_8344",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3124_8344"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 201.723,
    height: 200,
    fill: "white",
    transform: "translate(99.5 18)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEsim);
export default __webpack_public_path__ + "static/media/Esim.e1aa1ced0cb2571ed188764077cd950c.svg";
export { ForwardRef as ReactComponent };